/* eslint-disable */
import React from 'react';
import { Image, Platform } from 'react-native';
//import FastImage from 'react-native-fast-image' // https://github.com/DylanVann/react-native- fast-image
//import FastImage from '../Components/FastImage'

// https://snack.expo.io/@naqvitalha/rlv-demo

const isIOS = Platform.OS === 'ios';
let nth = 0
let aliveCount = 0

export class ImageRecycler extends React.Component {
  constructor(args) {
    super(args)
    aliveCount++
    this.nth = nth++
    this.loaded = { uri: null }
    this.currentOpacity = null
    // console.tron.log(`ImageRecycler #${this.nth} ${aliveCount} total`)
  }

  setOpacity(opacity) {
    if (this.imageRef && opacity !== this.currentOpacity) {
      this.imageRef.setNativeProps({
        opacity: opacity,
      })
      this.currentOpacity = opacity
    }
  }

  shouldComponentUpdate(newProps) {
    // console.tron.log(`ImageRecycler #${this.nth} shouldComponentUpdate source ${newProps.source.uri}`)
    // return this.props.source.uri !== newProps.source.uri
    const changed = this.props.source.uri !== newProps.source.uri
    if (changed)
      this.setOpacity(this.props.loadingOpacity)
    return changed
  }

  componentWillUpdate() {
    //On iOS while recycling till the new image is loaded the old one remains visible. This forcefully hides the old image.
    //It is then made visible onLoad
    // if (isIOS && this.imageRef) {
    if (isIOS && this.imageRef && this.props.source.uri != this.loaded.uri) {
      // console.tron.log(`ImageRecycler #${this.nth} componentWillUpdate not yet source ${this.props.source.uri} loaded: ${this.loaded.uri}`)
/*
      this.imageRef.setNativeProps({
        opacity: 0.05,
      })
*/
    }
    else {
      // console.tron.log(`ImageRecycler #${this.nth} componentWillUpdate source ${this.props.source.uri} loaded: ${this.loaded.uri}`)
    }
  }

  componentDidUpdate(previewProps, previewState) {
    // console.tron.log(`ImageRecycler #${this.nth} componentDidUpdate source ${this.props.source.uri}`)
    // this.setOpacity(1)
  }

  componentWillUnmount() {
    // console.tron.log(`ImageRecycler #${this.nth} componentWillUnmount (destroy), ${aliveCount} left`)
    aliveCount--
  }

  handleOnLoad = () => {
    if (isIOS && this.imageRef) {
      // console.tron.log(`ImageRecycler #${this.nth} handleOnLoad source ${this.props.source.uri}`)
      this.loaded = this.props.source
      this.setOpacity(1)
    }
  }

  render() {
/*
<Image
  ref={ref => {this.imageRef = ref}}
  style={this.props.style ? this.props.style : null}
  onLoad={this.handleOnLoad}
  source={this.props.source}
  resizeMode={this.props.resizeMode ? this.props.resizeMode : "cover"}
/>

<FastImage
  style={styles.image}
  source={{
    uri: 'https://unsplash.it/400/400?image=1',
    headers:{ Authorization: 'someAuthToken' },
    priority: FastImage.priority.normal,
  }}
  resizeMode={FastImage.resizeMode.contain}
/>
*/
    if (false && !this.props.useCache)
      return (
        <Image
          ref={ref => {this.imageRef = ref}}
          style={this.props.style ? this.props.style : null}
          onLoad={this.handleOnLoad}
          source={{
            uri: this.props.source.uri,
          }}
          resizeMode={this.props.resizeMode}
        />
      )
    else
      return (
        <Image
          ref={ref => {this.imageRef = ref}}
          style={this.props.style ? this.props.style : null}
          onLoad={this.handleOnLoad}
          source={{
            uri: this.props.source.uri,
            priority: 0 // FastImage.priority.normal,
          }}
          resizeMode={this.props.resizeMode ? this.props.resizeMode : 'cover' /*FastImage.resizeMode.cover */ /*FastImage.resizeMode.cover*/}
        />
      )
  }
}
